<script>
  import { format } from 'date-fns';

  export let row = {};
</script>

<div>{format(new Date(row.timestamp), 'MM/dd/yyyy')}</div>
<small>{format(new Date(row.timestamp), 'h:mm:ss a')}</small>

<style>
  small {
    color: var(--color-gray-600);
  }
</style>
